import { Component, inject, Input, OnInit } from '@angular/core';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { Hub } from '@qwyk/models';
import { CustomerPermissions } from '@qwyk/core';
import { UnderscoreToHyphenPipe } from '@qwyk/ui-standalone';
import { CustomerUsersService } from '@qwyk/hub/administration/data-access/customer-users';

@Component({
    selector: 'qwyk-customer-user-permissions',
    templateUrl: './customer-user-permissions.component.html',
    styleUrls: ['./customer-user-permissions.component.scss'],
    providers: [UnderscoreToHyphenPipe],
})
export class CustomerUserPermissionsComponent implements OnInit {

    private translate = inject(TranslateService);
    private service = inject(CustomerUsersService);
    private underscoreToHyphen = inject(UnderscoreToHyphenPipe);

    @Input() user: Hub.CustomerUser;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() permissions: any[];
    @Input() readonly = false;

    public hierarchy$ = of([]);
    private readonly _permission_list = CustomerPermissions as object;
    public readonly PERMISSION_LIST: { label: string; value: string }[] =
        Object.keys(this._permission_list)
            .map(e => {
                return {
                    label: this.translate.instant(
                        'hub.administration.portal-users.permissions.' +
                            this.underscoreToHyphen.transform(e.toLowerCase())
                    ),
                    value: this._permission_list[e],
                };
            })
            .sort((a, b) => (a.value > b.value ? 1 : -1));

    public readonly FILTERED_PERMISSION_LIST = this.PERMISSION_LIST.filter(
        e => !e.value.endsWith(':create') && !e.value.startsWith('attachments:')
    );

    public loading = true;
    public error = false;

    ngOnInit(): void {
        this.hierarchy$ = this.service.getHierarchy(this.user).pipe(
            catchError(() => {
                this.error = true;
                return of(null);
            }),
            tap(() => (this.loading = false))
        );
    }
}
